import AxiosInstance from 'utils/AxiosInstance'
import axios from 'axios'
import { useHistory } from 'react-router-dom'

// import { isLoading } from "containers/Main/actions";
import * as types from './constants'
// import config from "config";
// import { objectToCsv } from "../../helpers/index";

import {
  objectToCsv,
  BASE_URL_API as baseURLNode,
  SET_ACCESS_TOKEN as setToken,
  ACCESS_TOKEN as accessToken,
  validateEmail,
} from '../../utils/helpers'
import { userLogin } from 'store/user/actions'
import { clientBaseUrl } from 'utils/AxiosInstance'

/*eslint-disable */
const CancelToken = axios.CancelToken
let call1 = CancelToken.source()

const onLoad = (isLoading) => ({
  type: types.ON_LOAD,
  isLoading,
})

export const handleToggleModal = (modal) => {
  return (dispatch) => {
    if (modal === false) {
      dispatch(resetSelectedItems())
      dispatch(setPublic('public'))
      dispatch(
        setCurrentTab(
          null,
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups'
        )
      )
      dispatch(setAssignSearchValue(''))
    }
    dispatch({
      type: types.TOGGLE_MODAL,
      payload: modal,
    })
  }
}
export const resetSelectedItems = () => ({ type: types.RESET_SELECTED_ITEMS })
export const setAssignSearchValue = (assignSearchValue) => ({
  type: types.SET_ASSIGN_SEARCH_VALUE,
  assignSearchValue,
})

export const setCurrentTab = (
  event,
  currentTab,
  currentSelectedItems,
  currentItems,
  currentToggleFunction,
  currentShowSelectedItems,
  currentShowSelectedItemsFunction,
  currentHideSelectedItemsFunction
) => {
  return (dispatch) => {
    if (event !== null) {
      event.preventDefault()
    }
    dispatch({ type: types.SET_CURRENT_TAB, currentTab })
    dispatch({ type: types.SET_CURRENT_SELECTED_ITEMS, currentSelectedItems })
    dispatch({ type: types.SET_CURRENT_ITEMS, currentItems })
    dispatch({
      type: types.SET_CURRENT_TOGGLE_ITEM_FUNCTION,
      currentToggleFunction,
    })
    dispatch({
      type: types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
      currentHideSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
      currentShowSelectedItemsFunction,
    })
    dispatch({
      type: types.SET_CURRENT_SHOW_SELECTED_ITEMS,
      currentShowSelectedItems,
    })
  }
}

export const toggleOrgGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedOrgGroups } = getState().users

    const index = selectedOrgGroups.indexOf(id)

    let orgGroups = []

    if (index !== -1) {
      orgGroups = [
        ...selectedOrgGroups.slice(0, index),
        ...selectedOrgGroups.slice(index + 1),
      ]
    } else {
      orgGroups = [...selectedOrgGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_ORG_GROUPS, orgGroups })
  }
}

export const toggleUsers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().users

    const index = selectedUsers.indexOf(id)

    let users = []

    if (index !== -1) {
      users = [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]
    } else {
      users = [...selectedUsers, id]
    }

    dispatch({ type: types.SET_SELECTED_USERS, users })
  }
}

export const toggleLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedLocationGroups } = getState().users

    const index = selectedLocationGroups.indexOf(id)

    let locationGroups = []

    if (index !== -1) {
      locationGroups = [
        ...selectedLocationGroups.slice(0, index),
        ...selectedLocationGroups.slice(index + 1),
      ]
    } else {
      locationGroups = [...selectedLocationGroups, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATION_GROUPS, locationGroups })
  }
}

export const toggleLocations = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().users

    const index = selectedLocations.indexOf(id)

    let locations = []

    if (index !== -1) {
      locations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      locations = [...selectedLocations, id]
    }

    dispatch({ type: types.SET_SELECTED_LOCATIONS, locations })
  }
}

export const toggleStores = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().users

    const index = selectedStores.indexOf(id)

    let stores = []

    if (index !== -1) {
      stores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      stores = [...selectedStores, id]
    }

    dispatch({ type: types.SET_SELECTED_STORES, stores })
  }
}

export const toggleRoles = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().users

    const index = selectedRoles.indexOf(id)

    let roles = []

    if (index !== -1) {
      roles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      roles = [...selectedRoles, id]
    }

    dispatch({ type: types.SET_SELECTED_ROLES, roles })
  }
}

export const setShowSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: true,
})

export const setShowSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: true,
})
export const setHideSelectedUsers = () => ({
  type: types.SET_SHOW_SELECTED_USERS,
  showSelectedUsers: false,
})

export const setShowSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: false,
})

export const setShowSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: true,
})
export const setHideSelectedLocationGroups = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: false,
})

export const setShowSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})

export const setShowSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})

export const setHideSelectedOrgGroups = () => ({
  type: types.SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: false,
})

export const resetUser = () => ({ type: types.RESET_USER })
export const resetFilters = () => ({ type: types.RESET_FILTERS })
export const selectCSV = (file) => ({ type: types.CSV_FILE, file })
export const toggleArchived = () => ({ type: types.SET_TOGGLE_ARCHIVED })
export const selectRole = (roles) => ({ type: types.SELECT_ROLES, roles })
export const removeFilter = (name) => ({ type: types.REMOVE_FILTER, name })
export const searchUsers = (value) => ({ type: types.SEARCH_USERS, value })
export const selectStore = (stores) => {
  const newStores = stores.map((store) => store.option)

  return (dispatch) => {
    dispatch({ type: types.SELECT_STORE, stores: newStores })
  }
}

export const toggleArchivedUsers = () => ({
  type: types.TOGGLE_ARCHIVED_USERS,
})
export const selectGroup = (groups) => {
  return (dispatch) => {
    const userGroups = groups.map((group) => group.option)

    dispatch({
      type: types.SET_USER_GROUPS,
      groups: userGroups,
    })
  }
}

export const selectCourse = (courses) => {
  console.log('selectCourses', courses)
  const coursesOptions = courses.map((course) => course.option)
  return {
    type: types.SELECT_COURSE,
    courses: coursesOptions,
  }
}

export const selectExternalReport = (externalReports) => {
  console.log(externalReports, 'externalReports in actions')
  const externalReportsOptions = externalReports.map(
    (externalReport) => externalReport.option
  )
  console.log(externalReports, 'externalReports')
  return {
    type: types.SELECT_EXTERNAL_REPORT,
    externalReports: externalReportsOptions,
  }
}
export const setActivePages = (value) => ({
  type: types.SET_ACTIVE_PAGES,
  value,
})
export const setEmailFilter = (value) => ({
  type: types.SET_EMAIL_FILTER,
  value: value.replace('#', ''),
})
export const toggleLockUserData = () => ({
  type: types.SET_TOGGLE_LOCK_USER_DATA,
})

export const toggleFeedIgnore = () => {
  console.log('toggleFeedIgnore')

  return (dispatch) => {
    dispatch({ type: types.SET_IGNORE_FEED })
  }
}

export const toggleShowInManagerReport = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_SHOW_IN_MANAGER_REPORT })
  }
}

export const setUserRowData = (value) => ({
  type: types.SET_USERS_ROWS_DATA,
  value,
})
export const toggleTerminatedUsers = () => ({
  type: types.TOGGLE_TEERMINATED_USERS,
})
export const resetActivePages = () => ({
  type: types.SET_ACTIVE_PAGES,
  value: [1, 6],
})
export const setUsernameFilter = (value) => ({
  type: types.SET_USERNAME_FILTER,
  value: value.replace('#', ''),
})
export const setLastNameFilter = (value) => ({
  type: types.SET_LAST_NAME_FILTER,
  value: value.replace('#', ''),
})
export const setExtraField1Filter = (value) => ({
  type: types.SET_EXTRA_FIELD_1_FILTER,
  value: value.replace('#', ''),
})
export const setExtraField2Filter = (value) => ({
  type: types.SET_EXTRA_FIELD_2_FILTER,
  value: value.replace('#', ''),
})
export const setLastLoginFilter = (value) => ({
  type: types.SET_LAST_LOGIN_FILTER,
  value,
})
export const setUserColumnData = (value) => ({
  type: types.SET_USERS_COLUMN_DATA,
  value,
})
export const setRolesFilter = (value) => ({
  type: types.SET_SELECTED_ROLES_FILTER,
  value,
})
export const setFirstNameFilter = (value) => ({
  type: types.SET_FIRST_NAME_FILTER,
  value: value.replace('#', ''),
})
export const setExternalIdFilter = (value) => ({
  type: types.SET_EXTERNAL_ID_FILTER,
  value: value.replace('#', ''),
})
export const setAccessFilter = (value) => ({
  type: types.SET_SELECTED_ACCESS_FILTER,
  value,
})
export const setStoresFilter = (value) => ({
  type: types.SET_SELECTED_STORES_FILTER,
  value,
})
export const setUsersHaveChanges = (value) => ({
  type: types.SET_USERS_HAVE_CHANGES,
  value,
})
export const setShowArchivedUsers = (value) => ({
  type: types.SET_SHOW_ARCHIVED_USERS,
  value,
})
export const resetUsersExtendedDetails = () => ({
  type: types.SET_USERS_EXTENDED_DETAILS,
  data: [],
})
export const setCurrentPaginationPage = (value) => ({
  type: types.SET_CURRENT_PAGINATION_PAGE,
  value,
})
export const selectSecondAccessStore = (stores) => ({
  type: types.SELECT_SECOND_ACCESS_STORE,
  stores,
})
export const setCurrentPaginationOffset = (value) => ({
  type: types.SET_CURRENT_PAGINATION_OFFSET,
  value,
})
export const setPaginationTotalNumberOfPages = (value) => ({
  type: types.SET_TOTAL_PAGINATION_PAGES,
  value,
})
export const setLocationGroupsFilter = (value) => ({
  type: types.SET_SELECTED_LOCATION_GROUPS_FILTER,
  value,
})
export const setShowSelectedUsersItems = () => ({
  type: types.SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: true,
})
export const setHideSelectedUsersItems = () => ({
  type: types.SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: false,
})

export const setArchivedFilter = (nonArchived, archived) => {
  return (dispatch) => {
    nonArchived && archived
      ? dispatch({ type: types.SET_ARCHIVED_FILTER, value: '0,1' })
      : nonArchived
      ? dispatch({ type: types.SET_ARCHIVED_FILTER, value: '0' })
      : archived
      ? dispatch({ type: types.SET_ARCHIVED_FILTER, value: '1' })
      : dispatch({ type: types.SET_ARCHIVED_FILTER, value: '' })
  }
}

export const setArchivedFilterTrue = () => ({
  type: types.SET_ARCHIVED_FILTER_TRUE,
})

export const setStatusFilter = (active, term, loa) => {
  return (dispatch) => {
    let status = []
    active ? status.push(1) : null
    term ? status.push(2) : null
    loa ? status.push(3) : null
    dispatch({
      type: types.SET_SELECTED_STATUS_FILTER,
      value: status.map((item) => item).toString(),
    })
  }
}

export const removeSingleFilter = (filter, label) => {
  return (dispatch, getState) => {
    const { activeFilters } = getState().users
    delete activeFilters[label]

    dispatch(removeFilter(filter))
    dispatch(setActiveFilters(activeFilters))
  }
}

export const setHasActiveFilters = (value) => {
  return (dispatch) => {
    if (value) {
      dispatch({ type: types.SET_HAS_ACTIVE_FILTERS, value: true })
    } else {
      dispatch({ type: types.SET_HAS_ACTIVE_FILTERS, value: false })
      dispatch(resetFilters())
      dispatch(fetchUsersExtendedDetails())
    }
  }
}

export const setActiveFilters = (value) => {
  return (dispatch) => {
    dispatch({ type: types.SET_USERS_EXTENDED_DETAILS, data: [] })
    dispatch({ type: types.SET_ACTIVE_FILTERS, value })
    if (Object.keys(value).length !== 0) {
      dispatch(fetchUsersExtendedDetailsCountWithFilters(value))
      dispatch(fetchUsersExtendedDetailsWithFilters(value))
    } else {
      dispatch(fetchUsersExtendedDetails())
      dispatch(fetchUsersExtendedDetailsCountWithFilters())
    }
    dispatch(resetActivePages())
    dispatch(setCurrentPaginationPage(0))
    dispatch(setCurrentPaginationOffset(0))
  }
}

export const sendWelcomeEmail = (userId) => {
  console.log('userId', userId)
  return (dispatch, getState) => {
    // let language = {};
    // getState().language.language
    //   ? (language = getState().language.language.data)
    //   : null;
    if (
      confirm(
        'Are you sure you want to send a welcome email to this user?\nNOTE: The user password will also be reset!'
      )
    ) {
      AxiosInstance.post(`users/${userId}/send-welcome-email`, {
        status: true,
      })
      dispatch({
        type: types.SET_WELCOME_EMAIL_BUTTON_DISABLED,
        isWelcomeEmailButtonDisabled: true,
      })
    }
  }
}

export const me = () => {
  return (dispatch, getState) => {
    const { userLoaded } = getState().users

    if (userLoaded) {
      return
    }


    AxiosInstance.get('/users/self').then((data) => {
      delete data.language
      dispatch({ type: types.ME, me: data })
      dispatch(isLoading(types.LOADING, 'userLoaded', true))
    })
  }
}

export const lastActivity = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/self/last-activity`).then((data) => {
      dispatch({ type: types.LAST_ACTIVITY, lastActivity: data })

      dispatch(isLoading(types.LOADING, 'lastActivityLoaded', true))
    })
    // const { lastActivityLoaded } = getState().user
    // console.log('lastActivityLoaded', lastActivityLoaded)

    // if (lastActivityLoaded) {
    //   return
    // }
  }
}

export const onChange = (event) => {
  return (dispatch) => {
    const name = event.target.name
    const value = event.target.value

    dispatch({ type: types.USER_ON_CHANGE, name, value })
  }
}

export const onAvatarChange = (file) => {
  return (dispatch) => {
    const fileReader = new FileReader()

    fileReader.onload = (evt) => {
      dispatch({
        type: types.USER_ON_CHANGE,
        name: 'avatar',
        value: { url: evt.target.result },
      })
    }

    fileReader.readAsDataURL(file)

    dispatch({ type: types.USER_ON_CHANGE, name: 'avatarFile', value: file })
  }
}

export const updateUser = () => {
  return (dispatch, getState) => {
    const { id, first_name, last_name, avatarFile } = getState().users
    const { language } = getState().language

    const data = new FormData()

    data.append('file', avatarFile)
    data.append('id', id)
    data.append('first_name', first_name)
    data.append('last_name', last_name)
    data.append('language', language.id)

    dispatch({ type: types.USER_PROFILE_SAVE, status: 'Saving...' })

    return axios
      .put(`/users/self`, data)
      .then((data) => {
        dispatch({ type: types.ME, me: data })

        setTimeout(() => {
          dispatch({ type: types.USER_PROFILE_SAVE, status: 'Saved' })
        }, 500)

        setTimeout(() => {
          dispatch({ type: types.USER_PROFILE_SAVE, status: '' })
        }, 1500)
      })
      .catch(() => dispatch({ type: types.USER_PROFILE_SAVE, status: '' }))
  }
}

export const onChangeUser = (event) => {
  return (dispatch, getState) => {
    const name = event.target.name
    const value = event.target.value

    dispatch({ type: types.CURRENT_USER_ON_CHANGE, name, value })
  }
}

export const fetchUser = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/${id}/details`).then((data) => {
      if (data && data.id) {
        getState().users.allRoles.map((item) => item.name)

        let titleData = data.title.split(',')
        let roles = []

        titleData.map((item) => {
          getState().users.allRoles.map((items) => {
            item.toLowerCase() === items.name.toLowerCase()
              ? roles.push(items)
              : null
          })
        })

        let newData = data
        let newDataStores = []
        let newDataSecondAccessStores = []

        data.stores.map((item) => {
          if (item.access_type === 1) {
            newDataStores.push(item)
          } else if (item.access_type === 2) {
            newDataSecondAccessStores.push(item)
          }
        })

        newData.stores = newDataStores
        newData.secondAccessStores = newDataSecondAccessStores

        dispatch({ type: types.SET_USER, data: newData })

        const locations = data.groups.filter((item) => item.type === 'location')

        dispatch({ type: types.SET_USER_LOCATIONS, location: locations })
        dispatch({ type: types.SELECT_ROLES, roles: roles })

        dispatch({
          type: types.SET_SHOW_IN_MANAGER_REPORT,
          payload: data && data.dont_show_in_manager_report,
        })

        if (data.lock_user_data) {
          dispatch({ type: types.SET_LOCK_USER_DATA, lock_user_data: true })
        }

        if (data.feed_ignore) {
          dispatch({ type: types.SET_IGNORE_FEED })
        }

        if (data.archived) {
          dispatch({ type: types.SET_USER_ARCHIVED, isArchived: true })
        }

        if (data.birthdate) {
          dispatch(onDateChange(data.birthdate))
        }

        if (data.last_hire_date) {
          dispatch(onLastHireDateChange(data.last_hire_date))
        }

        if (data.second_access) {
          dispatch({
            type: types.SET_TOGGLE_SECOND_ACCESS,
            isSecondAccess: true,
          })
          dispatch({
            type: types.SET_SELECTED_SECOND_ACCESS,
            second_access: data.second_access,
          })
        }
      }
    })
  }
}

export const fetchUsers = () => {
  return (dispatch) => {
    dispatch(onLoad(true))
    AxiosInstance.get('/users').then((data) => {
      if (Array.isArray(data)) {
        data = data.map((item) => {
          return {
            ...item,
            avatar:
              typeof item.avatar === 'string' ? JSON.parse(item.avatar) : null,
          }
        })
        dispatch({ type: types.SET_USERS, data })
        dispatch(onLoad(false))
        dispatch(fetchRoles())
      }
    })
  }
}

export const fetchAssignableUsers = () => {
  return (dispatch) => {
    AxiosInstance.get('/users/assign').then((data) => {
      if (Array.isArray(data)) {
        data = data.map((item) => {
          return {
            ...item,
            avatar:
              typeof item.avatar === 'string' ? JSON.parse(item.avatar) : null,
          }
        })
        dispatch({ type: types.SET_ASSIGNABLE_USERS, data })
        dispatch(onLoad(false))
        dispatch(fetchRoles())
      }
    })
  }
}

export const setCreatingLoading = (boolean) => ({
  type: types.SET_CREATING_LOADING,
  payload: boolean,
})

export const sendWelcomeEmailToAllUsers = (
  emailType,
  selection,
  setShowSendWelcomeModal,
  setSendingEmail
) => {
  return (dispatch, getState) => {
    const {
      selectedOrgGroups,
      selectedLocationGroups,
      selectedLocations,
      selectedRoles,
      selectedStores,
      subject,
      welcomeSubject,
      body,
      welcomeBody,
      notLoggedInUsers,
    } = getState().users

    let { selectedUsers } = getState().users

    if (emailType === 'welcome' && selection === 'automatic') {
      let users = []
      if (notLoggedInUsers && notLoggedInUsers.length) {
        users = notLoggedInUsers.map((u) => u.id)
      }
      selectedUsers = users
      dispatch({ type: types.SET_SELECTED_USERS, users })
    }

    if (
      !selectedOrgGroups.length &&
      !selectedLocationGroups.length &&
      !selectedRoles.length &&
      !selectedUsers.length &&
      !selectedStores.length
    ) {
      if (
        !confirm(
          'No filter selected. Email will be sent to all users! Are you sure you want to continue?'
        )
      )
        return
    }

    const data = {
      groups: [...selectedOrgGroups, ...selectedLocationGroups],
      users: selectedUsers,
      stores: selectedStores,
      roles: selectedRoles,
      emailBody:
        emailType === 'custom'
          ? JSON.stringify({ body })
          : JSON.stringify({ body: welcomeBody }),
      emailSubject: emailType === 'custom' ? subject : welcomeSubject,
      emailType,
    }

    if (emailType === 'custom' && !subject) {
      alert('Email subject cannot be empty!')
      return
    }

    if (emailType === 'welcome' && !welcomeSubject) {
      alert('Email subject cannot be empty!')
      return
    }

    AxiosInstance.post('/users/send-welcome-email', {
      ...data,
    }).then(() => {
      setSendingEmail(true)
      setShowSendWelcomeModal(false)
      dispatch(resetSelectedItems())
    })
  }
}

export const getNotLoggedInUsers = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/not-logged-in`).then((data) => {
      dispatch({ type: types.SET_NOT_LOGGED_IN_USERS, payload: data })
    })
  }
}

export const onChangeEmailBody = (value) => async (dispatch) => {
  dispatch({ type: types.ON_CHANGE_EMAIL_BODY, name: 'body', value })
}

export const onChangeWelcomeEmailBody = (value) => async (dispatch) => {
  dispatch({
    type: types.ON_CHANGE_WELCOME_EMAIL_BODY,
    name: 'welcomeBody',
    value,
  })
}

export const onChangeEmailSubject = (value) => ({
  type: types.ON_CHANGE_EMAIL_SUBJECT,
  payload: value,
})

export const onChangeWelcomeEmailSubject = (value) => ({
  type: types.ON_CHANGE_WELCOME_EMAIL_SUBJECT,
  payload: value,
})

export const fetchWelcomeEmailTemplate = () => {
  return (dispatch) => {
    AxiosInstance.get('/settings/welcome-email-template').then((data) => {
      dispatch({ type: types.SET_WELCOME_EMAIL_TEMPLATE, payload: data || {} })
    })
  }
}

export const saveWelcomeEmailTemplate = (setSavingTemplate) => {
  return (dispatch, getState) => {
    const { welcomeSubject, welcomeBody } = getState().users

    if (!welcomeSubject) {
      alert('Email subject cannot be empty!')
      return
    }

    setSavingTemplate && setSavingTemplate(true)

    AxiosInstance.post('/settings/welcome-email-template', {
      welcomeSubject,
      welcomeBody,
    })
      .then(() => {
        setSavingTemplate && setSavingTemplate(false)
      })
      .catch(() => {
        setSavingTemplate && setSavingTemplate(false)
      })
  }
}

export const saveUser = (history, backPath) => {
  return (dispatch, getState) => {
    const { user, users, isSecondAccess, archivedUsers } = getState().users

    const index = users.findIndex((item) => item.id === user.id)
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!user.first_name) {
      alert('Please type your First Name')
      return
    }
    if (!user.last_name) {
      alert('Please type your Last Name')
      return
    }
    if (!user.email) {
      alert('Please type your Email Name')
      return
    }
    if (!validateEmail(user.email)) {
      alert('Please input a valid email')
      return
    }
    // if (archivedUserIndex !== -1) {
    // 	alert(
    // 		'A user with the same email already exists, please contact your manager to activate your account or create a new one!'
    // 	)
    // 	return
    // }

    if (!user.username) {
      alert('Please type your Username')
      return
    }

    if (
      (Number(user.access) === 2 || Number(user.access === 3)) &&
      !user.roles.length
    ) {
      alert('Please assign a job title to employee')
      return
    }
    if (!user.code) {
      alert('Please type Team Member ID')
      return
    }
    if (user.access === 3 && !user.stores.length) {
      alert('Please assign the team member to at least to one location')
      return
    }
    if (isSecondAccess) {
      if (!user.second_access) {
        alert('Please select an access level for the second location')
        return
      }
      if (!user.secondAccessStores.length) {
        alert(
          'Please assign the user to at least to one second access location '
        )
        return
      }
    }
    const {
      avatar,
      gender,
      last_login,
      progress,
      hire_date,
      groups,
      location,
      title,
      lockUserData,
      lastHireDate,
      isArchived,
      courses,
      allowRolesSwitch,
      feedIgnore,
      birthdate,
      showInManagerReport,
      ...otherProps
    } = user
    const formatedStores = otherProps.stores.map((item) => {
      !item.access_type ? (item.access_type = 1) : null
      return item
    })
    const formatedSecondAccessStores = otherProps.secondAccessStores.map(
      (item) => {
        !item.access_type ? (item.access_type = 2) : null
        return item
      }
    )

    dispatch(setCreatingLoading(true))

    const newStores = [...formatedStores, ...formatedSecondAccessStores]
    console.log(newStores, 'stores here')
    const getGroupsOnly = groups.filter((group) => group.type === 'course')
    const groupsAndLocations = getGroupsOnly.concat(location)
    let userTitle = user.roles.map((item) => item.name)

    AxiosInstance[user.id ? 'put' : 'post'](
      `/users${user.id ? '/' + user.id : ''}`,
      {
        ...otherProps,
        stores: JSON.stringify(newStores),
        courses: JSON.stringify(otherProps.courses),
        groups: JSON.stringify(groupsAndLocations),
        title: userTitle.join(','),
        second_access: isSecondAccess ? user.second_access : null,
        lock_user_data: lockUserData ? 1 : 0,
        archived: isArchived ? 1 : 0,
        allow_switch_roles: allowRolesSwitch ? 1 : 0,
        feed_ignore: feedIgnore ? 1 : 0,
        dont_show_in_manager_report: showInManagerReport ? 1 : 0,
        birthdate: birthdate,
        last_hire_date: lastHireDate,
        courses: JSON.stringify(courses),
        externalReports: JSON.stringify(otherProps.externalReports),
        // loginLink: `${window.location.protocol}//${window.location.host}/auth/login`,
        // notifyLink: `${window.location.protocol}//${window.location.host}/course`,
      }
    )
      .then((data) => {
        console.log(data, 'dataFromBack')
        dispatch(resetFilters())
        dispatch(setActiveFilters({}))
        dispatch({ type: types.SET_USERS_EXTENDED_DETAILS, data: [] })
        dispatch(fetchUsersExtendedDetails())
        dispatch(fetchUsers())
        if (history) {
          history.push(backPath)
        } else {
          console.error('History object not available.')
        }
        dispatch(setCreatingLoading(false))
      })
      .catch((response) => {
        alert(response.response.data.message)
        dispatch(setCreatingLoading(false))
      })
  }
}

export const deleteUser = (id) => {
  return (dispatch, getState) => {
    let language = {}
    // getState().language.language
    // 	? (language = getState().language.language.data)
    // 	: null
    if (confirm('Are you sure you want to delete this user?')) {
      const { users } = getState().users
      const newUsers = users.filter((item) => item.id !== id)

      dispatch({ type: types.SET_USERS, data: newUsers })

      AxiosInstance.delete(`/users/${id}`).then(() => {
        dispatch(resetUsersExtendedDetails())
        dispatch(fetchUsersExtendedDetails())
      })
    }
  }
}

export const unArchiveUser = (id) => {
  return (dispatch, getState) => {
    const { users } = getState().users
    const newUsers = users.filter((item) => item.id !== id)

    dispatch({ type: types.SET_USERS, data: newUsers })

    AxiosInstance.post(`/users/${id}`, { status: null })
  }
}

export const fetchStores = () => {
  return (dispatch) => {
    AxiosInstance.get('/stores').then((data) => {
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_STORES, data })
      }
    })
  }
}
export const uploadCSV = (event) => {
  console.log('leart983')
  console.log('Debbuger')
  return (dispatch, getState) => {
    event.preventDefault()

    const { csvFile, uploadCSVStatus } = getState().users
    console.log('csvFIle', csvFile)
    console.log('uploadCSVStatus', uploadCSVStatus)

    if (!csvFile) {
      alert('Select csv file')
      return
    }

    if (uploadCSVStatus !== '') {
      alert('Please wait')
      return
    }

    const data = new FormData()

    data.append('file', csvFile)

    dispatch({ type: types.UPLOAD_CSV_STATUS, status: 'started' })

    axios
      .post(`${clientBaseUrl()}/users/import?token=${accessToken()}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )

          dispatch({ type: types.UPLOAD_CSV_PERCENT, percent })
        },
      })
      .then(() => {
        alert('Users added successfully')

        dispatch({ type: types.UPLOAD_CSV_STATUS, status: '' })
        dispatch({ type: types.UPLOAD_CSV_PERCENT, percent: 0 })
        location = '/user-management'
      })
  }
}

export const onPasswordChange = (event) => {
  return (dispatch) => {
    const name = event.target.name
    const value = event.target.value

    dispatch({ type: types.USER_PASSWORD_CHANGE, name, value })
  }
}

export const savePassword = () => {
  return (dispatch, getState) => {
    const { password, newPassword, confirmNewPassword } = getState().users
    let language = {}
    // getState().language.systemDefaultLanguage
    // 	? (language = getState().language.systemDefaultLanguage.data)
    // 	: null
    if (!password) {
      alert(language.alerts ? language.alerts.type_your_password : null)
      // alert('Please type your password')
      return
    }

    if (!newPassword) {
      alert(language.alerts ? language.alerts.type_new_password : null)
      // alert('Please type your new password')
      return
    }

    if (password === newPassword) {
      alert(language.alerts ? language.alerts.type_different_password : null)
      // alert('Please type different password')
      return
    }

    if (newPassword !== confirmNewPassword) {
      alert(language.alerts ? language.alerts.new_pasword_doesnt_match : null)
      // alert('New password doesn\'t match')
      return
    }

    dispatch({ type: types.USER_PASSWORD_SAVE, status: 'Saving...' })

    return AxiosInstance.post('/users/self/change-password', {
      password,
      newPassword,
      confirmNewPassword,
    }).then((response) => {
      if (!response.success) {
        dispatch({ type: types.USER_PASSWORD_SAVE, status: '' })

        alert(
          response.message ||
            (language.alerts ? language.alerts.smth_wrong : null)
        )
      } else {
        dispatch({ type: types.USER_PASSWORD_SAVE, status: 'Saved' })
        // alert(response.message)

        setTimeout(() => {
          dispatch({ type: types.USER_PASSWORD_SAVE, status: '' })
          dispatch({
            type: types.USER_PASSWORD_CHANGE,
            name: 'password',
            value: '',
          })
          dispatch({
            type: types.USER_PASSWORD_CHANGE,
            name: 'newPassword',
            value: '',
          })
          dispatch({
            type: types.USER_PASSWORD_CHANGE,
            name: 'confirmNewPassword',
            value: '',
          })
        }, 1500)
      }
    })
  }
}

export const fetchUsersDetails = () => {
  return (dispatch) => {
    AxiosInstance.get('/users/details').then((data) => {
      dispatch({ type: types.SET_USERS_DETAILS, data })
    })
  }
}

export const selectLocation = (location) => {
  const newLoc = location.map((loc) => loc.option)

  return (dispatch, getState) => {
    dispatch({ type: types.SET_USER_LOCATIONS, location: newLoc })
    const getGroupsOnly = getState().users.user.groups.filter(
      (group) => group.type === 'course'
    )

    const mergeGroups = getGroupsOnly.concat(newLoc)
    dispatch({ type: types.SET_USER_GROUPS, groups: mergeGroups })
  }
}

export const selectRegion = (region) => {
  const newRegion = region.map((item) => item.option)

  return (dispatch) => {
    dispatch({ type: types.SET_USER_REGIONS, region: newRegion })
    console.log(newRegion)
  }
}

export const fetchUserSubmission = () => {
  return (dispatch) => {
    AxiosInstance.get('/users/self/submissions').then((submissions) => {
      if (Array.isArray(submissions)) {
        dispatch({ type: types.SET_USER_SUBMISSIONS, submissions })
      }
    })
  }
}

export const fetchRoles = () => {
  return (dispatch) => {
    AxiosInstance.get('/roles').then((roles) => {
      dispatch({ type: types.SET_ROLES, roles })
    })
  }
}

export const proxyIntoUser = (userId) => {
  return (dispatch) => {
    AxiosInstance.get(`/users/switch-account/${userId}`).then((data) => {
      if (data && data.token) {
        setToken(data.token)
        setTimeout(() => {
          setTimeout(() => {
            location = '/dashboard'
          }, 500)
          dispatch(userLogin())
        }, 500)
      }
    })
  }
}

export const resetProxy = () => {
  return (dispatch) => {
    setToken(localStorage.getItem('top_proxy'))
    setTimeout(() => {
      setTimeout(() => {
        location = '/settings/users'
      }, 500)
      dispatch(userLogin())
    }, 500)
  }
}

export const toggleSecondAccess = () => {
  return (dispatch, getState) => {
    const { isSecondAccess } = getState().users

    dispatch({
      type: types.SET_TOGGLE_SECOND_ACCESS,
      isSecondAccess: !isSecondAccess,
    })
  }
}

export const fetchUsersExtendedDetails = (data) => {
  return (dispatch, getState) => {
    const { usersExtendedDetails, currentPaginationOffset } = getState().users
    AxiosInstance.get(
      `/users/details/extended?offset=${
        data && data.offset ? data.offset : '0'
      }&count=300&()}`
    ).then((data) => {
      data.map((obj) => {
        if (obj.last_login) {
          obj.last_login = obj.last_login.split('T')[0]
        }
        if (obj.last_activity) {
          obj.last_activity = obj.last_activity.split('T')[0]
        }
      })
      if (data) {
        dispatch({
          type: types.SET_USERS_EXTENDED_DETAILS,
          data: [...usersExtendedDetails, ...data],
        })
        dispatch(setCurrentPaginationOffset(currentPaginationOffset + 300))
      }
    })
  }
}

export const fetchUsersExtendedDetailsWithFilters = (data) => {
  return (dispatch, getState) => {
    const { usersExtendedDetails, currentPaginationOffset } = getState().users
    const conditions = []
    if (data) {
      if (data.offset) {
        conditions.push(`offset=${data.offset}`)
      }
      if (data.first_name) {
        conditions.push(`first_name=${encodeURI(data.first_name.value)}`)
      }
      if (data.last_name) {
        conditions.push(`last_name=${data.last_name.value}`)
      }
      if (data.extra_field_1) {
        conditions.push(`extra_field_1=${data.extra_field_1.value}`)
      }
      if (data.extra_field_2) {
        conditions.push(`extra_field_2=${data.extra_field_2.value}`)
      }
      if (data.last_login) {
        conditions.push(`last_login=${data.last_login.value}`)
      }
      if (data.last_activity) {
        conditions.push(`last_activity=${data.last_activity.value}`)
      }
      if (data.email) {
        conditions.push(`email=${data.email.value}`)
      }
      if (data.username) {
        conditions.push(`username=${data.username.value}`)
      }
      if (data.external_id) {
        conditions.push(`external_id=${data.external_id.value}`)
      }
      if (data.access && data.access.value.length) {
        conditions.push(`access=${data.access.value}`)
      }
      if (data.status && data.status.value) {
        conditions.push(`status=${data.status.value}`)
      }
      if (data.archived) {
        conditions.push(`archived=${data.archived.value}`)
      }
      if (data.group && data.group.value.length) {
        conditions.push(`group=${data.group.value}`)
      }
      if (data.store && data.store.value.length) {
        conditions.push(`store=${data.store.value}`)
      }
      if (data.role && data.role.value.length) {
        conditions.push(`role=${data.role.value}`)
      }

      conditions.push('count=300')
    }
    AxiosInstance.get(`/users/details/extended?${conditions.join('&')}`).then(
      (data) => {
        data.length > 0 &&
          data.map((obj) => {
            if (obj.last_login) {
              obj.last_login = obj.last_login.split('T')[0]
            }
            if (obj.last_activity) {
              obj.last_activity = obj.last_activity.split('T')[0]
            }
          })
        dispatch({
          type: types.SET_USERS_EXTENDED_DETAILS,
          data: Object.keys(data).length
            ? [...usersExtendedDetails, ...data]
            : [],
        })
        dispatch(setCurrentPaginationOffset(currentPaginationOffset + 300))

        const count = data.length ? data.length : 0

        dispatch({ type: types.SET_TOTAL_NUMBER_OF_USERS, value: count })
        dispatch(setPaginationTotalNumberOfPages(Math.ceil(count / 50)))
      }
    )
  }
}

export const fetchUsersExtendedDetailsCount = () => {
  return (dispatch) => {
    AxiosInstance.get(`/users/details/extended/count?status=1`).then((data) => {
      dispatch({ type: types.SET_TOTAL_NUMBER_OF_USERS, value: data.count })
      dispatch(setPaginationTotalNumberOfPages(Math.ceil(data.count / 50)))
    })
  }
}

export const fetchUsersManagerApproval = () => {
  return (dispatch) => {
    AxiosInstance.get(`/manager-reports/needs-manager-approval/users`).then(
      (data) => {
        dispatch({ type: types.SET_MANAGER_APPROVAL_USERS, data })
      }
    )
  }
}

export const fetchUsersGroupManagerApproval = () => {
  return (dispatch) => {
    AxiosInstance.get(
      `/manager-reports/needs-manager-approval/group-users`
    ).then((data) => {
      dispatch({ type: types.SET_GROUP_MANAGER_APPROVAL_USERS, data })
    })
  }
}

export const fetchUsersExtendedDetailsCountWithFilters = (data) => {
  return (dispatch) => {
    const conditions = []
    if (data) {
      if (data.first_name) {
        conditions.push(`first_name=${encodeURI(data.first_name.value)}`)
      }
      if (data.last_name) {
        conditions.push(`last_name=${data.last_name.value}`)
      }
      if (data.extra_field_1) {
        conditions.push(`extra_field_1=${data.extra_field_1.value}`)
      }
      if (data.extra_field_2) {
        conditions.push(`extra_field_2=${data.extra_field_2.value}`)
      }
      if (data.last_login) {
        conditions.push(`last_login=${data.last_login.value}`)
      }
      if (data.last_activity) {
        conditions.push(`last_activity=${data.last_activity.value}`)
      }
      if (data.email) {
        conditions.push(`email=${data.email.value}`)
      }
      if (data.username) {
        conditions.push(`username=${data.username.value}`)
      }
      if (data.external_id) {
        conditions.push(`external_id=${data.external_id.value}`)
      }
      if (data.access && data.access.value.length) {
        conditions.push(`access=${data.access.value}`)
      }
      if (data.status && data.status.value) {
        conditions.push(`status=${data.status.value}`)
      }
      if (data.archived) {
        conditions.push(`archived=${data.archived.value}`)
      }
      if (data.group && data.group.value.length) {
        conditions.push(`group=${data.group.value}`)
      }
      if (data.store && data.store.value.length) {
        conditions.push(`store=${data.store.value}`)
      }
      if (data.role && data.role.value.length) {
        conditions.push(`role=${data.role.value}`)
      }
    }

    AxiosInstance.get(
      `/users/details/extended/count?${conditions.join('&')}`
    ).then((data) => {
      dispatch({ type: types.SET_TOTAL_NUMBER_OF_USERS, value: data.count })
      dispatch(setPaginationTotalNumberOfPages(Math.ceil(data.count / 50)))
    })
  }
}

export const fetchUserPrivileges = () => {
  return (dispatch) => {
    AxiosInstance.get(`/users/privileges`).then((data) => {
      dispatch({
        type: types.SET_USER_PRIVILEGES,
        mainModules: data.main_modules,
        settingsModules: data.settings_modules,
        dataModules: data.data_modules,
      })
    })
  }
}

export const onClickExportButton = (object) => {
  return (dispatch, getState) => {
    console.log('getState()', getState())
    const { access, second_access, usersExtendedDetails } = getState().users

    const getCSV = () => {
      let content = objectToCsv(usersExtendedDetails)
      var filename = 'users.csv'

      let blob = new Blob([content], {
        encoding: 'UTF-8',
        type: 'text/csv;charset=UTF-8',
      })

      let blobUrl = window.URL.createObjectURL(blob)

      let csvLink = document.createElement('a')
      csvLink.href = blobUrl
      csvLink.download = filename
      csvLink.click()
    }

    getCSV()
  }
}

export const fetchUserRewards = () => {
  return (dispatch) => {
    AxiosInstance.get(`/rewards/earned`).then((data) => {
      dispatch({ type: types.SET_USER_REWARDS, data })
    })
  }
}

export const fetchUserRoles = () => {
  return (dispatch, getState) => {
    const userId = getState().users.id
    AxiosInstance.get(`stores/user-roles/${userId}`).then((data) => {
      const userRoles = data && data[0] && JSON.parse(data[0].user_roles)
      dispatch({ type: types.SET_USER_ROLES, userRoles })
    })
  }
}

export const onDateChange = (date) => ({
  type: types.SET_USER_BIRTHDATE,
  date,
})

export const onLastHireDateChange = (date) => ({
  type: types.SET_USER_LAST_HIRE_DATE,
  date,
})
export const fetchArchivedUsers = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/details/extended?archived=1&count=300`).then(
      (data) => {
        dispatch({
          type: types.SET_ARCHIVED_USERS,
          data,
        })
      }
    )
  }
}
